import type { ChannelKind, HorizontalAlignment } from '@visiba/api-vcs-client-v2';

export interface FlexibleBaseSpecification {
	id: number;
	order: number;
	horizontalAlignment: HorizontalAlignment;
	channel?: ChannelKind | null;
}

export abstract class FlexibleModelBase {
	public readonly id: number;
	public readonly order: number;
	public readonly horizontalAlignment: HorizontalAlignment;
	public readonly channel: ChannelKind | null;

	constructor(spec: FlexibleBaseSpecification) {
		this.id = spec.id;
		this.order = spec.order;
		this.horizontalAlignment = spec.horizontalAlignment;
		this.channel = spec.channel ?? null;
	}
}
